import { render, staticRenderFns } from "./TransferIncorrect.vue?vue&type=template&id=71190b98&scoped=true&"
import script from "./TransferIncorrect.vue?vue&type=script&lang=js&"
export * from "./TransferIncorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71190b98",
  null
  
)

export default component.exports